// extracted by mini-css-extract-plugin
module.exports =  {"currencyContainer":"InvoicesTable_currencyContainer__7hKmi","tablePaymentScheduleDetail":"InvoicesTable_tablePaymentScheduleDetail__Syjzb"};